module.exports = __webpack_public_path__ + "media/images/players/POULTER_IAN-d578af84b9b14fdb3ab5af9efacfdb6c.png";